module.exports = __webpack_public_path__ + "media/05.af145400.mp4";